/**
 * 运单节点监控请求
 */
import request from '@/utils/http';
const otpBaseUrl = '/api-antms/query';
// const otpBaseUrl = '';

// 运单节点监控列表
export const queryWaybillNodeMonitorList = data => {
    return request({
        url: `${otpBaseUrl}/transport/monitor/page`,
        method: 'post',
        data
    });
};

// 运单节点监控-列表分页统计数量;
export const queryCount = data => {
    return request({
        url: `${otpBaseUrl}/transport/monitor/pageCount`,
        method: 'post',
        data
    });
};

// 运单节点监控-运单汇总
export const queryWayBillSummary = data => {
    return request({
        url: `${otpBaseUrl}/transport/monitor/order`,
        method: 'post',
        data
    });
};

// 运单节点监控-任务汇总
export const queryTaskSummary = data => {
    return request({
        url: `${otpBaseUrl}/transport/monitor/task`,
        method: 'post',
        data
    });
};
